/**
 * This  modal component use for to Delete the recognise fellow
 */
 import { useEffect, useState } from "react";
 import { withRouter } from "react-router-dom";
 import { connect } from "react-redux";
 import Modal from "../../common/Modal";
 import Button from "../../common/Button";
 import "./style.scss";
 import { useHistory } from "react-router-dom";
 import InputField from "../../common/InputField";
 import { makeStyles } from "@material-ui/core/styles";
 import FormValidator from "./FormValidator";
 import TextareaField from "../../common/TextAreaField";
 import {setAdminCohortAppStatus} from "../Dashboard/AdminDashboard/AdminMentorAction/dependencies/action"
 import { updateApplicationStatus } from "../Dashboard/AdminDashboard/ViewApplication/dependencies/action";
 import {postStatusMentorCohort,postStatusStartupCohort} from "../Dashboard/MentorDashboard/dependencies/action";
 const useStyles = makeStyles((theme) => ({
   input: {
     backgroundColor: "white"  }
 }));
 const SubmitAction = (props) => {
   const {
     onClose,
     action,
     submitData,
   } = props;
   const { updateApplicationStatus, updatedStatus,setAdminCohortAppStatus,postStatusMentorCohort } = props;
   const history = useHistory();
   const classes = useStyles();
   const [errorMessagePurpose, setErrorMessagePurpose] = useState("*Please Enter Reason")
   const [errorVisible7, SetErrorVisible7] = useState(false);
   const [filterData7, setFilterData7] = useState();
   const [wordCounter, setWordCounter] = useState(0);
   

   const testWordLimit= (data) =>{
     let value = data?.length === 0 ? 0 : data?.replace(/(^\s*)|(\s*$)/gi,"")?.replace(/[ ]{2,}/gi," ")?.split(' ')?.length;
     
     if(value == 150)
     {
       setErrorMessagePurpose("Exceeds limit of 150 words.")
       SetErrorVisible7(true)
     }
     else if(value < 150 && value > 0){
       SetErrorVisible7(false)
       setErrorMessagePurpose("*Please Enter Reason")
     }
     else if(value == 0){
       SetErrorVisible7(true)
       setErrorMessagePurpose("*Please Enter Reason")
     }
     else if (value > 150 ) {
      setWordCounter(150);
      return value;
    }
     setWordCounter(value);
     return value
   }
   useEffect(() => {
     
   }, []);
 
   const defaultFormData = {
     reason: "",
   };
   const onBlur = () => {
     validateInput();
     
   };
   const validateInput = () => {
 
     // const {reason  } = formData;
     // const formStatus = FormValidator.validatePopup({
     //   reason
     // });
 
     // const errors = {
     //   reason: formStatus.reason,
       
     // };
     // setError(errors);
     // return !formStatus.hasErrors;
   };
   const [formData, setFormData] = useState(defaultFormData);
   const [error, setError] = useState({});
   const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] =
   useState(false);
   const handleInputChange = (e) => {
     const { value, name } = e.target;
 
     setFormData((user) => {
       return { ...user, [name]: value };
     });
   };
   const setUpdateApplicationStatus =(status) => {
    
     if (testWordLimit(filterData7) > 0 && testWordLimit(filterData7) < 151) {
      let params ;
      if(props.formName === "cohortApp")
      {
           params = {
            id: props.submitData.id,
            status: props.submitData.status,
            comments: filterData7,
          };
      }
      else if(props.formName === "mentorCohort" || props.formName === "startupCohort" ){
        params = props.rejectData;
      }
      else{
       params = {
        id: submitData.id,
        status: submitData.status,
        comments: filterData7,
      };
    }
       
       //
       if(props.formName === "cohortApp" || props.formName ===  "newCohortDashboard"){
        setAdminCohortAppStatus(params)
       }
       else if(props.formName === "mentorCohort"){
        postStatusMentorCohort(params);
       }
       else if(props.formName === "startupCohort"){
        postStatusStartupCohort(params);
       }
       else
       updateApplicationStatus(params).then((res) => {
         if (res) {
           if (res) {
             // setIsActionSubmit(true)
           }
         }
         //   onClose();
         // localStorage.setItem("mentorMenu", "mentorMenu");
         // props.history.push("./dashboard");
   
       });
        setTimeout(() => {
        if(props.formName === "cohortApp"){
          localStorage.setItem("cohortApplication", "cohortApplication");
        }
        if(props.formName === "newCohortDashboard"){
          localStorage.setItem("MyCohortMentorDashboard", "MyCohortMentorDashboard");
        }
        else if(props.formName === "mentorCohort"){
          localStorage.setItem("cohortMentors", "cohortMentors");
         }
        else if(props.formName === "startupCohort" ){
          localStorage.setItem("cohortStartup", "cohortStartup");
         }
        else{
          localStorage.setItem("mentorMenu", "mentorMenu");
        }
        onClose()
       }, 1000);
      ;

     }else{
     // alert(status)
     setHasInvalidSubmitOccurred(true);
    //  onClose();
     }
   };
   return (
     <div className="add-profile-block submitAction">
       <div className="add-profile-head">
         <h2>
           {submitData && submitData.status=="REJECTED" ? "Reason for Reject " :"Request More Info"}
         </h2>
       </div>
       <TextareaField
         id="reason"
         variant="outlined"
         placeholder="Describe in maximum 150 words"
         fullWidth
         margin="normal"
         name="reason"
         rows={8}
         InputProps={{ className: classes.input }}
         // className="purposeBox"
         maxRows={10}
         value={filterData7}
         onChange={(e) => {
         if(testWordLimit(e.target.value) < 151){
                   setFilterData7(e.target.value)
                       }
                       }}
                     />
              <div className="wordCounter d-flex justify-content-end">
                      Word Count: {wordCounter} / 150
                    </div>
       {/* <InputField
         required={true}
         id="reason"
         label="Type Here"
         variant="outlined"
         fullWidth
         margin="normal"
         onChange={handleInputChange}
         value={formData.reason}
         name="reason"
         error={error.reason}
         onBlur={onBlur}
         hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
       /> */}
          {errorVisible7 && (
                 <div className="login-error-msg mt-2">{errorMessagePurpose}</div>
               )}
       <div className="add-profile-footer">
         <Button

           onClick={() => {
             setUpdateApplicationStatus(action);
           }}
           text="Submit"
           className="submit reasonrejectsubmitbutton submitactionbtn"
         />
       </div>
       </div>
 
   );
 };
 const mapStateToProps = (state) => {
   return {
     updatedStatus: state.AdminMentorViewReducer.updateApplicationStatus.data,
   };
 };
 export default connect(mapStateToProps, { updateApplicationStatus,setAdminCohortAppStatus,postStatusMentorCohort })(
   withRouter(Modal(SubmitAction))
 );
